module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-altenergy@2x.png?1ce831b7489b76ba1bdf0798d89b4fb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-altenergy@2x.png
// module id = 1026
// module chunks = 1